<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable v-if="detailTDO">
			<v-card>
				<v-card-title class="headline">
					<span>Detail Pengiriman Transfer Stok</span>
					<span class="pl-2 font-weight-bold">{{detailTDO.tdo_code}}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">{{detailTDO.tdo_type == 'in' ? 'Warehouse Pengirim' : 'Warehouse Tujuan'}}</div>
							<div v-if="detailTDO.tdo_type == 'in' && detailTDO.warehouse_from">
								<div class="pt-1">{{ detailTDO.warehouse_from.warehouse_name }}</div>
								<div class="pt-1">{{ detailTDO.warehouse_from.warehouse_mobilephone }}</div>
								<div class="pt-1"> {{ addressText(detailTDO.warehouse_from) }}</div>
							</div>
							<div v-else-if="detailTDO.tdo_type == 'out' && detailTDO.warehouse_to">
								<div class="pt-1">{{ detailTDO.warehouse_to.warehouse_name }}</div>
								<div class="pt-1">{{ detailTDO.warehouse_to.warehouse_mobilephone }}</div>
								<div class="pt-1"> {{ addressText(detailTDO.warehouse_to) }}</div>
							</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Pengiriman Transfer Stok</div>
							<v-col cols="6" class="mt-1 pa-0">
								<div class="primary rounded text-subtitle-2 font-weight-bold text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 d-flex justify-center">
									{{detailTDO.tdo_status | toStatusPDOWH}}
								</div>
							</v-col>
							<div class="text-subtitle-1 mt-3 font-weight-bold">Catatan</div>
							<v-col cols="12" class="pa-0">
								<div class="pt-1">{{detailTDO.tdo_note ? detailTDO.tdo_note : '-'}}</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Detail Produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailTDO.tdo_detail" hide-default-footer>
							<template v-slot:item.tdo_detail_quantity_sent="{ item }">
								<div>{{ item.tdo_detail_quantity_sent | toNumber }}</div>
							</template>
							<template v-slot:item.tdo_detail_quantity_received="{ item }">
								<div>{{ item.tdo_detail_quantity_received | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Status Transfer Stok</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailTDO.tdo_status_delivered_user_id">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTDO.tdo_status == 'delivered' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'delivered' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTDO.tdo_status_delivered_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTDO.tdo_status_on_delivery_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTDO.tdo_status == 'on_delivery' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'on_delivery' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTDO.tdo_status_on_delivery_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTDO.tdo_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTDO.tdo_status == 'created' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailTDO.tdo_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-3" text @click="hideDialog" class="text-capitalize">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'tdo_detail_product_name'},
			{ text: 'Jumlah Dikirim', value: 'tdo_detail_quantity_sent'},
			{ text: 'Jumlah Diterima', value: 'tdo_detail_quantity_received'},
			],
		}
	},
	computed:{
		...mapState('tdo', ['detailTDO']),
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		}
	}
}
</script>